import { resolveScreenshotTarget, canShowActivity, showsSuitestream } from '../../components/AreaOverview/screenPreviewTarget';
import { getScreenNowPlaying, foregroundActivity } from '../../utils/screenActivity';

export function getVenueNowPlaying(summary, now = Date.now()) {
  const devicesById = new Map((summary?.playbackDevices || []).map((device) => [Number(device.id), device]));
  const liveStates = summary?.playbackStates || {};
  return (summary?.screens || []).map((screen) => {
    const televisionState = liveStates[screen.televisionDeviceId]?.state;
    let result = getScreenNowPlaying(screen, devicesById, liveStates, televisionState?.tvInputManager, now);
    let deviceId = result.activeDeviceId || result.reportedDeviceId;
    // Preserve unmanaged-display controls; no TV input confirmation is possible here.
    if (screen.displayKind === 'unmanaged' && !deviceId && !result.confirmed) {
      deviceId = screen.playbackTargetId;
      const activity = foregroundActivity(liveStates[deviceId], now);
      result = { ...result, reportedDeviceId: activity.fresh && activity.known ? deviceId : null, title: activity.title || result.title, activity, artworkUrl: activity.artworkUrl,
        source: `${screen.playbackTargetName || 'Player'} · TV input unverified` };
    }
    const activity = result.activity;
    const target = resolveScreenshotTarget(result, devicesById, liveStates, summary?.nativeBindings || {});
    return {
      nowPlaying: result, target,
      wantsSnapshot: canShowActivity(result) && !showsSuitestream(result) && !target.reason,
      screenId: screen.id, screenName: screen.name, title: result.title,
      artworkUrl: result.artworkUrl || null, source: result.source,
      controlDeviceId: Number(deviceId || screen.playbackTargetId || screen.televisionDeviceId) || null,
      isExternalApp: activity?.isExternalApp === true,
      foregroundAppKey: activity?.packageName || activity?.appName || '',
      isSpotify: activity?.isSpotify === true,
      isSuitestream: activity?.isSuitestream === true,
      mixDisabled: activity?.mixDisabled === true,
    };
  });
}
